import { SubscriptionType } from "types/enums";

const tierHierarchy = [SubscriptionType["FREE"], SubscriptionType["PREMIUM"], SubscriptionType["PRO"]];

export default tierHierarchy;
